import * as React from "react";

import { RouteComponentProps } from "react-router";
import { Card, CardBody, Col, Container, Row } from "reactstrap";
import RegistrationForm from "./RegistrationForm";


type OwnProps =
    RouteComponentProps<{
        token: string;
    }>

interface BAN {
    ban: string;
    bills: Bill[];
}

interface Bill {

    cdt: string,
    pdfurl: string,
    rqstyp: string | undefined,
    dev: string | undefined,
    systran: string

}

interface accountState {
    bans: BAN[];
    isLoading: boolean;
}
export class registration extends React.Component<OwnProps> {
    public state: accountState = {
        bans: [],
        isLoading: false,

    };

    constructor(props: Readonly<OwnProps>) {
        super(props);
    }
    // This method is called when the component is first added to the document
    public componentDidMount() {
        this.ensureDataFetched();
    }

    private ensureDataFetched() {

    }
    public render() {
        return (
            <Container>
                <Row>
                    <Col />
                    <Col lg="8">
                        <Container>
                            <h3>
                                Frontier CABS Bill Portal
                            </h3>
                            <h4>
                                New User Registration
                            </h4>

                            <hr />
                            <Card>
                                <CardBody>
                                    <RegistrationForm />
                                </CardBody>
                            </Card>
                        </Container>
                    </Col>
                    <Col />
                </Row>
            </Container>
        );
    }
}
